// extracted by mini-css-extract-plugin
export default {"fixedScroll":"Accordion_fixedScroll__M9A5O"};